
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/--roboneo/seedance",
      function () {
        return require("private-next-pages/--roboneo/seedance/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/--roboneo/seedance"])
      });
    }
  